import BaseService from './base'
import axios from '@/plugins/axios'

export default class NotificationService extends BaseService {
  static resource() {
    return 'api/v1/external/notification'
  }

  static async policyNotification(accountCode) {
    const { data } = await axios.get(
      `${this.baseURL()}/${this.resource()}/${accountCode}`
    )
    return data
  }

  static async savePolicyResponse(accountCode, payload = {}) {
    const { data } = await axios.post(
      `${this.baseURL()}/${this.resource()}/${accountCode}`,
      payload
    )
    return data
  }
}
